export const FALLBACK_BEHAVIOR_DESCRIPTIONS: Record<
  'none' | 'last_possible_moment' | 'time_of_use',
  string
> = {
  none: "No fallback behavior is configured. It will use the default fallback behavior, charge at last possible moment.",
  last_possible_moment:
    'EVs charge as late as possible before departure, maximizing the flexibility window. Recommended for most use cases.',
  time_of_use: 'Charging decisions are deferred to the Time-of-Use optimization service.',
}
